<template>
    <div>

        <config-main-title>
            Outras Configurações
        </config-main-title>

        <div v-if="dados">

            <div class="card">
                <div class="card-body">

                    <div class="card"> 
                        <div class="card-header">
                            <a class="card-link" data-toggle="collapse" href="#collapseConfig" role="button">
                                Configurações Iniciais
                            </a>
                        </div>

                        <div class="collapse" id="collapseConfig">
                            <div class="card-body">

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Tempo máximo de alteração do prontuário (em dias)"
                                            type="number"
                                            :validate="validate"
                                            v-model="lista.in_edita_prontuario" />
                                    </div>
                                </div>

                                <div class="my-3">

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Realiza atendimento SUS"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="lista.fl_sus" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Pré-cadastro para pacientes primeira vez agendados"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="lista.fl_agenda_pre_cadastro" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="CheckIn na Unidade"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="lista.fl_checkin_na_unidade" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Portal do Paciente"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="lista.fl_portal" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Teleatendimento"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="lista.fl_tele_atendimento" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Utiliza Número de Prontuário"
                                                type="checkbox-group"
                                                :validate="validate"
                                                v-model="lista.fl_numero_prontuario" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Impressão de Documentos"
                                                type="select"
                                                :validate="validate"
                                                :optionsList="[
                                                    { id: 'E', search: 'Imprimir logo na esquerda' },
                                                    { id: 'D', search: 'Imprimir logo na direita' },
                                                    { id: 'C', search: 'Imprimir logo centralizado' },
                                                ]"
                                                optionsData="id"
                                                optionsDisplay="search"
                                                v-model="lista.ch_impressao_logo_posicao" />
                                        </div>
                                    </div>

                                </div>

                                <div class="row" v-if="lista.fl_tele_atendimento">
                                    <div class="col col-12">
                                        <az-input
                                            label="Termo de Consentimento do Teleatendimento"
                                            type="textarea"
                                            rows="10"
                                            :validate="validate"
                                            v-model="lista.st_tele_termo_consentimento" />
                                    </div>
                                </div>

                                <!-- Envio de Mensagem -->
                                <az-sub-title title="Envio de Mensagem para o Paciente" class="mt-3" />

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            :label="'Bot Telegram para Comunicação com o Paciente' + ( lista.st_telegram_bot_name ? ' (' + lista.st_telegram_bot_name + ')' : '' )"
                                            type="checkbox-group"
                                            :validate="validate"
                                            v-model="lista.telegram_bot" />
                                    </div>
                                </div>

                                <template v-if="$store.state.user.id_usuario == 1">

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                :label="'Número Whatsapp para Comunicação com o Paciente' + ( lista.st_whatsapp_number ? ' (' + lista.st_whatsapp_number + ')' : '' )"
                                                type="checkbox-group"
                                                :validate="validate"
                                                :edicao="$store.state.user.id_usuario == 1"
                                                v-model="lista.tem_whatsapp" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                label="Habilitar envio de SMS para Comunicação com o Paciente"
                                                type="checkbox-group"
                                                :validate="validate"
                                                :edicao="$store.state.user.id_usuario == 1"
                                                v-model="lista.tem_sms"
                                                @input="lista.st_sms_number = lista.tem_sms ? 1 : ''" />
                                        </div>
                                    </div>

                                </template>

                                <!-- Financeiro -->
                                <az-sub-title title="Financeiro" class="mt-3" />
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Receita Apurada por Operadora"
                                            type="checkbox-group"
                                            :validate="validate"
                                            v-model="lista.fl_receita_por_operadora" />
                                    </div>
                                </div>

                                <!-- Pagamento On-line -->
                                <az-sub-title title="Pagamento on-line" class="mt-3" />

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Pagamento on-line"
                                            type="checkbox-group"
                                            :validate="validate"
                                            v-model="lista.fl_pag_online" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Pagamento on-line somente para teleatendimento"
                                            type="checkbox-group"
                                            :validate="validate"
                                            v-if="lista.fl_pag_online && lista.fl_tele_atendimento"
                                            v-model="lista.fl_pag_online_telemed" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Provedor"
                                            type="select"
                                            :validate="validate"
                                            :optionsList="[
                                                { id: 'Cielo', search: 'Cielo' },
                                            ]"
                                            optionsData="id"
                                            v-if="lista.fl_pag_online"
                                            v-model="lista.st_pag_online_provider">
                                            <template v-slot:button-pos>
                                                <div class="input-group-append" v-if="lista.st_pag_online_provider">
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="test_config_pagamento()"
                                                        data-toggle="tooltip" data-placement="top" title="Validar Configuração"
                                                        v-if="lista.is_config_provider">
                                                        <div class="spinner-border spinner-border-sm" role="status" v-if="testing">
                                                        <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <i class="fa fa-check" aria-hidden="true" v-else></i>
                                                    </button>
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="config_proced()"
                                                        v-if="lista.is_config_provider"
                                                        data-toggle="tooltip" data-placement="top" title="Habilitar Procedimentos">
                                                        <i class="fa fa-play" aria-hidden="true"></i>
                                                    </button>
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="config_pagamento()"
                                                        data-toggle="tooltip" data-placement="top" title="Configurar Chave Cielo">
                                                        <i class="fa fa-cogs" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            type="select"
                                            label="Tipo Chave PIX"
                                            :optionsList="[
                                                { id: 'random', search: 'aleatória' },
                                                { id: 'document', search: 'CPF/CNPJ' },
                                                { id: 'email', search: 'email' },
                                                { id: 'phone', search: 'telefone'}
                                            ]"
                                            optionsData="id"
                                            optionsDisplay="search"
                                            v-model="lista.st_pix_tipo" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            v-if="lista.st_pix_tipo"
                                            placeholder="Chave PIX..."
                                            :type="lista.st_pix_tipo == 'phone' ? 'fone' :
                                                ( lista.st_pix_tipo == 'email' ? 'email' :
                                                    ( lista.st_pix_tipo == 'document' ? 'cpf-cnpj' : 'text' ) )"
                                            label="Chave PIX"
                                            required
                                            :validate="validate"
                                            v-model="lista.st_pix_chave" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            v-if="lista.st_pix_tipo"
                                            placeholder="e-mail..."
                                            type="email"
                                            label="E-mail para recebimento dos comprovantes"
                                            required
                                            :validate="validate"
                                            v-model="lista.st_pix_email_comprovante" />
                                    </div>
                                </div>

                                <!-- Mapa de Sala -->
                                <az-sub-title title="Mapa de Sala" class="mt-3" />

                                <div class="row">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Manhã (Início)"
                                            type="number"
                                            :validate="validate"
                                            v-model="lista.js_turnos.M.de" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Tarde (Início)"
                                            type="number"
                                            :validate="validate"
                                            v-model="lista.js_turnos.T.de" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Noite (Início)"
                                            type="number"
                                            :validate="validate"
                                            v-model="lista.js_turnos.N.de" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Noite (Fim)"
                                            type="number"
                                            :validate="validate"
                                            v-model="lista.js_turnos.N.ate" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Outras Configurações -->

                    <p class="alert alert-info mt-3">Outras Parâmetros</p>

                    <div class="mt-3">
                        <az-input
                            icon="fa fa-search"
                            v-model="search" />
                    </div>

                    <table class="table table-sm border-0 table-responsive mt-3">
                        <tr>
                            <td class="text-nowrap">
                                <a href="#" @click.prevent="filtrar(group)" v-for="(group, icx) in grupos" :key="icx">
                                    <span class="badge badge-success mr-1" >
                                        {{ group }}
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </table>

                    <div v-for="(configs, grupo, idx) in outras" :key="idx">
                        <az-sub-title :title="grupo" class="mt-3" />
                        <div class="row" v-for="(config, icx) in configs" :key="'C' + idx + '.' + icx">
                            <div class="col col-12" v-if="!isDrTisHook(config.st_slug)">
                                <az-input
                                    :type="config.st_tipo == 'boolean' ? 'checkbox-group' : config.st_slug == 'dmed-operadora-particular' ? 'select' : config.st_tipo"
                                    :label="config.st_titulo"
                                    v-model="config.st_valor"
                                    :optionsList="config.st_slug == 'integracap-pacs' ? servicos : (config.st_slug == 'integracao-whatsapp' ? servicos_whatsapp : undefined)"
                                    :optionsDisplay="config.st_slug == 'integracap-pacs' ? 'name' : config.st_slug == 'dmed-operadora-particular' ? 'st_operadora' : ''"
                                    :optionsData="config.st_slug == 'integracap-pacs' ? 'id' : (config.st_slug == 'dmed-operadora-particular' ? 'id_operadora' :  (config.st_slug == 'integracao-whatsapp' ? 'id' : ''))"

                                    :optionsMode="config.st_slug == 'dmed-operadora-particular' ? 'aql' : undefined"
                                    :service="config.st_slug == 'dmed-operadora-particular' ? 'operadoras.index' : undefined"

                                    :icon="config.st_tipo == 'password' ? 'fas fa-eye': ''"
                                    :buttonIcon="config.st_tipo == 'password' ? true : false"
                                    :buttonText="config.st_tipo == 'password' ? 'fas fa-eye': ''"
                                    @clickButton="showInfo(config.st_valor, config)"
                                    >
                                    <template v-slot:buttonposcb>
                                        <div class="input-group-append">
                                            <button
                                                v-if="showWhatsappGenericButton(config)"
                                                class="btn btn-outline-primary"
                                                type="button"
                                                @click="abrirModalWhatsappGenerico()">
                                                <i class="fab fa-whatsapp"></i> Configurar WhatsApp Genérico
                                            </button>
                                            <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="showInfo(config.st_instrucao, config)" v-if="config.st_instrucao">
                                                <i class="far fa-compass"></i>
                                            </button>
                                            <az-audit-log-button model="configuracao" :id="config.id_configuracao"/>
                                        </div>
                                    </template>

                                    <template v-slot:buttonposb v-if="config.st_tipo != 'boolean'">
                                        <div class="input-group-append">
                                            <button
                                                v-if="showWhatsappGenericButton(config)"
                                                class="btn btn-outline-primary"
                                                type="button"
                                                @click="abrirModalWhatsappGenerico()">
                                                <i class="fab fa-whatsapp"></i> Configurar WhatsApp Genérico
                                            </button>
                                            <az-audit-log-button model="configuracao" :id="config.id_configuracao"/>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12" v-else>
                                <az-submit class="my-3" @click="drTisWebhook()">
                                    <i class="fas fa-x-ray"></i> Configurar Webhook do Dr. Tis
                                </az-submit>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light" v-if="dados">
                <div>
                    <az-submit @click="atualizar ()" class="mr-2">Atualizar</az-submit>
                    <az-audit-log-button model="parametroUnidade" :id="lista.id_parametro_unidade"/>
                </div>
            </nav>

        </div>

        <div v-else>
            <az-empty-state msg="Nenhum parâmetro identificado." />
        </div>

        <!-- Habilitar Procedimentos -->
        <procedimentos-pag-online ref="proceds" />

        <!-- Modal -->
        <div class="modal fade" id="providerConfigModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="config_pag">
                    <div class="modal-header">
                        <h5 class="modal-title">Configuração {{ lista.st_provider }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Merchant Id"
                            :placeholder="lista.is_config_provider ? 'Atualizar Configuração...' : 'Inserir configuração...'"
                            v-model="config_pag.merchant_id" />

                        <az-input
                            class="mt-3"
                            label="Merchant Key"
                            :placeholder="lista.is_config_provider ? 'Atualizar Configuração...' : 'Inserir configuração...'"
                            v-model="config_pag.merchant_key" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_config_pag()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="telegramTokenPortal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="lista">
                    <div class="modal-header">
                        <h5 class="modal-title">Telegram</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <ul>
                            <li>Baixe o telegram:
                                <a href="https://desktop.telegram.org/" class="card-link" target="_blank">
                                    Clique aqui
                                </a>
                            </li>
                            <li>Crie o Bot do Telegram:
                                <a href="https://t.me/BotFather" class="card-link" target="_blank">
                                    Criar Bot do Telegram
                                </a>
                            </li>
                            <li>Ao abrir o Telegram no BotFather, escolha a opção /newbot</li>
                            <li>Preencha o TOKEN do BOT criado no campo abaixo e clique em atualizar</li>
                        </ul>

                        <az-input
                            label="Token do BOT do Telegram"
                            type="text"
                            v-model="lista.st_telegram_bot_token" />

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_telegram()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Config Whatsapp -->
        <div class="modal fade" id="waModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="lista && lista.tem_whatsapp">
                    <div class="modal-header">
                        <h5 class="modal-title">Whastapp</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Número"
                            required
                            :validate="validate"
                            placeholder="Informar o Número..."
                            v-model="lista.st_whatsapp_number" />

                        <az-input
                            label="Segredo"
                            required
                            :validate="validate"
                            placeholder="Informar o Segredo..."
                            v-model="lista.st_whatsapp_segredo" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="save_config_wa()">Configurar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Config SMS -->
        <div class="modal fade" id="smsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="lista && lista.tem_sms">
                    <div class="modal-header">
                        <h5 class="modal-title">SMS</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Número"
                            required
                            :validate="validate"
                            placeholder="Informar o Número..."
                            v-model="lista.st_sms_number" />

                        <az-input
                            label="Segredo"
                            required
                            :validate="validate"
                            placeholder="Informar o Segredo..."
                            v-model="lista.st_sms_segredo" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="save_config_sms()">Configurar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Instrução Modal -->
        <div class="modal fade" id="instrucaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Informação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="config_info && config_info.st_slug && $store.state.user.id_usuario == 1">
                            <strong>{{ config_info.st_slug }}</strong>
                            <div>{{ config_info.st_valor }}</div>
                        </div>

                        <div class="alert alert-secondary">
                            {{ instrucao }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Instrução Modal -->
        <div class="modal fade" id="drTisModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Configurar Webhook Dr. Tis</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="dados_drtis">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Hook: Laudo emitido"
                                    placeholder="Hook: O laudo em PDF foi emitido..."
                                    v-model="dados_drtis.hook_report_created.url"
                                    />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Hook: Estudo em andamento"
                                    placeholder="Hook: O estudo está em andamento, chegou a primeira imagem..."
                                    v-model="dados_drtis.hook_study_ongoing.url"
                                    />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="ativarHooks()">Atualizar Hooks</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal WhatsApp Generico -->
        <div class="modal fade" id="whatsappGenericoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Configurar WhatsApp Genérico</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="URL"
                                    placeholder="https://api.exemplo.com/whatsapp"
                                    v-model="whatsappGenericoConfig.st_url">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <select
                                                class="custom-select custom-select-sm"
                                                style="max-width: 140px;"
                                                v-model="whatsappGenericoConfig.st_metodo">
                                                <option v-for="method in httpMethods" :key="method.id" :value="method.id">
                                                    {{ method.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="mt-3">
                            <az-sub-title title="Headers">
                                <a href="#" @click.prevent="addWhatsappHeader()" class="card-link ml-2" title="Adicionar header">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </a>
                            </az-sub-title>

                            <div
                                class="form-row"
                                v-for="(header, index) in whatsappGenericoConfig.js_headers"
                                :key="'wa-header-' + index">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        :compact="true"
                                        sizing="sm"
                                        label="Key"
                                        placeholder="Ex.: Authorization"
                                        required2
                                        :validate="validate"
                                        v-model="header.key" />
                                </div>
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        :compact="true"
                                        sizing="sm"
                                        label="Value"
                                        placeholder="Bearer token"
                                        required
                                        :validate="validate"
                                        v-model="header.value">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-outline-danger btn-sm" @click="removeWhatsappHeader(index)" title="Remover header">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3">
                            <az-input
                                sizing="sm"
                                type="textarea"
                                rows="12"
                                label="Body"
                                placeholder='{"phone":"[telefone]","message":"[mensagem]"}'
                                ref="whatsappBody"
                                required
                                :validate="validate"
                                v-model="whatsappGenericoConfig.st_body" />
                        </div>

                        <div class="mt-3">
                            <az-input
                                sizing="sm"
                                type="select"
                                label="Tags Fixas"
                                placeholder="Selecione uma tag para inserir no Body..."
                                :optionsList="whatsappTags"
                                optionsDisplay="search"
                                optionsData="id"
                                v-model="whatsappGenericoConfig.tagSelecionada"
                                @change="inserirTagNoBody" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="d-flex align-items-end mr-auto">
                            <az-input
                                sizing="sm"
                                placeholder="ID da Marcação"
                                v-model="waTestIdMarcacao">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button @click="testarWhatsappGenerico()" class="btn btn-sm btn-info">Testar (confirmar marcação)</button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <button type="button" class="btn btn-secondary" @click="cancelarConfigWhatsappGenerico()">Cancelar</button>
                        <az-submit @click="salvarConfigWhatsappGenerico()">Salvar</az-submit>
                    </div>
                    <div v-if="temWhatsappTesteRetorno" class="border-top p-3">
                        <div class="small text-muted mb-2">Dados de retorno</div>
                        <div class="alert alert-secondary mb-0">
                            <vue-json-pretty :data="whatsappTesteRetorno" :showLength="true" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import ProcedimentosPagOnline from '../shared/ProcedimentosPagOnline.vue';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    data () {
        return {
            dados: null,
            validate: false,
            config_pag: null,
            modal_aberto: "",
            testing: false,
            instrucao: "",
            servicoes: null,
            servicos_whatsapp: null,
            search: "",
            dados_drtis: null,
            httpMethods: [
                { id: 'GET', name: 'GET' },
                { id: 'POST', name: 'POST' },
                { id: 'PUT', name: 'PUT' },
                { id: 'PATCH', name: 'PATCH' },
                { id: 'DELETE', name: 'DELETE' },
            ],
            whatsappTags: [
                { id: '#numero_whatsapp', search: '#numero_whatsapp' },
                { id: '#id_template', search: '#id_template' },
                { id: '#placeholders_array', search: '#placeholders_array' },
                { id: '#placeholders_json', search: '#placeholders_json' },
            ],
            whatsappGenericoConfig: {
                st_url: '',
                st_metodo: 'POST',
                js_headers: [],
                st_body: '',
                tagSelecionada: '',
            },
            waTestIdMarcacao: '',
            whatsappTesteRetorno: null,
            config_info: null, 
        }
    },

    components: {
        ConfigMainTitle,
        AzInput,
        AzSubmit,
        AzEmptyState,
        AzAuditLogButton,
        AzSubTitle,
        ProcedimentosPagOnline,
        VueJsonPretty,
    },

    computed: {
        grupos: function () { 
            if ( !this.lista )
                return [];

            return _.uniq(
                _.map(this.lista.config.filter(item => item.perfil), item => item.perfil.st_perfil)
            ).sort();
        },

        lista: function () {
            if ( this.dados && this.dados.length == 1 ) {
                return this.dados[0];
            } else {
                return [];
            }
        },

        outras: function () {
            if ( !this.lista || !this.lista.config )
                return [];

            let reg = this.$util.getregex(this.search);

            return _.groupBy(this.lista.config.filter(item => !this.search || reg.test(JSON.stringify(item)) ), 'perfil.st_perfil');
        },

        temWhatsappTesteRetorno: function () {
            if (Array.isArray(this.whatsappTesteRetorno)) {
                return this.whatsappTesteRetorno.length > 0;
            }

            if (_.isPlainObject(this.whatsappTesteRetorno)) {
                return !_.isEmpty(this.whatsappTesteRetorno);
            }

            return false;
        },

    },

    watch: {
        'lista.telegram_bot': function (newValue) {
            if ( newValue && !this.$store.state.loading ) {
                $('#telegramTokenPortal').modal('show');
            }
        },

        'lista.tem_whatsapp': function (newValue) {
            if ( !this.$store.state.loading ) {
                if ( newValue ) {
                    $('#waModal').modal('show');
                } else {
                    this.lista.st_whatsapp_number = null;
                }
            }
        },

    },

    methods: {
        showWhatsappGenericButton(config) {
            return !!config
                && config.st_slug == 'integracao-whatsapp'
                && String(config.st_valor || '').trim().toLowerCase() == 'whatsappgenericohelper';
        },

        abrirModalWhatsappGenerico() {
            this.validate = false; 

            this.$util.load (this, {
                service: 'configuracao_whatsapp',
                func: 'show',
                loadTo: (res) => {
                    const dados = res && res.data ? res.data : res;

                    this.whatsappGenericoConfig = {
                        ...this.whatsappGenericoConfig,
                        st_metodo: _.get(dados, 'st_metodo', 'POST') || 'POST',
                        st_url: _.get(dados, 'st_url', '') || '',
                        js_headers: this.normalizarWhatsappHeaders(_.get(dados, 'js_headers', [])),
                        st_body: _.get(dados, 'st_body', '') || '',
                        tagSelecionada: '',
                    };
                    this.whatsappTesteRetorno = null;

                    $('#whatsappGenericoModal').modal('show');
                }
            });
        },

        addWhatsappHeader() {
            this.whatsappGenericoConfig.js_headers.push({ key: '', value: '' });
        },

        normalizarWhatsappHeaders(headers) {
            if (!Array.isArray(headers) || !headers.length) {
                return [];
            }

            return headers.map(item => ({
                key: _.get(item, 'key', ''),
                value: _.get(item, 'value', ''),
            }));
        },

        inserirTagNoBody(tag) {
            const valorTag = _.get(tag, 'id', tag);

            if (!valorTag) {
                return;
            }

            const componenteBody = this.$refs.whatsappBody;
            const textarea = componenteBody && componenteBody.$el ? componenteBody.$el.querySelector('textarea') : null;
            const bodyAtual = this.whatsappGenericoConfig.st_body || '';

            if (!textarea) {
                this.whatsappGenericoConfig.st_body = bodyAtual + valorTag;
                this.whatsappGenericoConfig.tagSelecionada = '';
                return;
            }

            const inicio = typeof textarea.selectionStart === 'number' ? textarea.selectionStart : bodyAtual.length;
            const fim = typeof textarea.selectionEnd === 'number' ? textarea.selectionEnd : bodyAtual.length;

            this.whatsappGenericoConfig.st_body = bodyAtual.slice(0, inicio) + valorTag + bodyAtual.slice(fim);
            this.whatsappGenericoConfig.tagSelecionada = '';

            this.$nextTick(() => {
                textarea.focus();
                const posicao = inicio + valorTag.length;
                if (textarea.setSelectionRange) {
                    textarea.setSelectionRange(posicao, posicao);
                }
            });
        },

        removeWhatsappHeader(index) {
            this.whatsappGenericoConfig.js_headers.splice(index, 1);

            if (!this.whatsappGenericoConfig.js_headers.length) {
                this.whatsappGenericoConfig.js_headers.push({ key: '', value: '' });
            }
        },

        cancelarConfigWhatsappGenerico() {
            this.whatsappTesteRetorno = null;
            $('#whatsappGenericoModal').modal('hide');
        },

        testarWhatsappGenerico() {
            this.salvarConfigWhatsappGenerico(() => { 
                this.$util.atualizar(this, {
                    service: 'configuracao_whatsapp',
                    func: 'teste',
                    dados: {
                        id_marcacao: this.waTestIdMarcacao,
                    },
                    callback: (res) => {
                        this.whatsappTesteRetorno = _.get(res, 'dados_retorno', null);
                        if (res && res.msg) {
                            this.$toast.add({
                                severity: res.status_code && res.status_code >= 400  ? "error" : "success",
                                summary: "Atenção",
                                detail: res.msg,
                                life: 3000
                            });
                            return;
                        }
                    }
                });
            }); 
        },

        salvarConfigWhatsappGenerico(func_pos_save = null) {
            this.$util.atualizar (this, {
                service: 'configuracao_whatsapp',
                func: 'store',
                dados: {
                    st_metodo: this.whatsappGenericoConfig.st_metodo,
                    st_url: this.whatsappGenericoConfig.st_url,
                    js_headers: this.whatsappGenericoConfig.js_headers,
                    st_body: this.whatsappGenericoConfig.st_body,
                },
                callback: () => {
                    if (func_pos_save) {
                        func_pos_save();
                    } else { 
                        $('#whatsappGenericoModal').modal('hide');
                    }
                }
            });
        },

        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        isDrTisHook(slug) {
            const pacs = _.first(this.lista.config.filter(item => item.st_slug == 'integracap-pacs'));
            const pacsServico = _.first(this.servicos.filter(item => item.id == _.get(pacs, 'st_valor')));

            const isDrTis = (pacsServico && pacsServico.name && pacsServico.name.toUpperCase() == "DRTIS");

            return (slug == 'integracao-pacs-drtis-hook') && isDrTis;
        },

        showInfo (texto, config) {
            this.instrucao = texto;
            this.config_info = _.cloneDeep(config); 

            $('#instrucaoModal').modal('show');
        },

        ativarHooks() {
            const usuario = _.first(this.lista.config.filter(item => item.st_slug == 'integracao-pacs-drtis-usuario'));
            const senha = _.first(this.lista.config.filter(item => item.st_slug == 'integracao-pacs-drtis-senha'));
            const account = _.first(this.lista.config.filter(item => item.st_slug == 'integracao-pacs-drtis-id-conta'));
            const accessKey = _.first(this.lista.config.filter(item => item.st_slug == 'integracap-pacs-clientid'));

            this.$util.atualizar(this, {
                service: 'drtis',
                func: 'updateHooks',
                dados: {
                    usuario: usuario ? usuario.st_valor : '',
                    senha: senha ? senha.st_valor : '',
                    id_conta: account ? account.st_valor : '',
                    accessKey: accessKey ? accessKey.st_valor : '',
                    hook_report_created_id: this.dados_drtis.hook_report_created.id,
                    hook_report_created_url: this.dados_drtis.hook_report_created.url ? this.dados_drtis.hook_report_created.url : '' ,
                    hook_study_ongoing_id: this.dados_drtis.hook_study_ongoing.id,
                    hook_study_ongoing_url: this.dados_drtis.hook_study_ongoing.url ? this.dados_drtis.hook_study_ongoing.url : '',
                },
                toast: false,
                callback: res => {
                    $('#drTisModal').modal('hide');

                    if(res && res.status && res.status == 'ERRO') {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.msg,
                            life: 3000
                        });
                        return;
                    }

                    if(res && res.status && res.status == 'OK') {
                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: res.msg,
                            life: 3000
                        });
                        return;
                    }
                }
            });
        },

        drTisWebhook () {
            //const pacs = _.first(this.lista.config.filter(item => item.st_slug == 'integracap-pacs'));
            //const pacsServico = _.first(this.servicos.filter(item => item.id == pacs.st_valor));

            //if(pacsServico && pacsServico.name && pacsServico.name.toUpperCase() == "DRTIS") {

                //this.drTisLoadHooks(() => {
                    $('#drTisModal').modal('show');
                //});
                //return;
            //}

            //this.$toast.add({
                    //severity: "error",
                    //summary: "Atenção",
                    //detail: "A integração do Pacs não é o Dr. Tis",
                    //life: 3000
                //});
        },

        drTisLoadHooks(callback) {
            const usuario = _.first(this.lista.config.filter(item => item.st_slug == 'integracao-pacs-drtis-usuario'));
            const senha = _.first(this.lista.config.filter(item => item.st_slug == 'integracao-pacs-drtis-senha'));
            const account = _.first(this.lista.config.filter(item => item.st_slug == 'integracao-pacs-drtis-id-conta'));

            this.$util.atualizar(this, {
                service: 'drtis',
                func: 'loadHooks',
                dados: {
                    usuario: usuario ? usuario.st_valor : '',
                    senha: senha ? senha.st_valor : '',
                    id_conta: account ? account.st_valor : '',
                },
                toast: false,
                callback: res => {

                    if(res && res.status && res.status == 'ERRO') {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.msg,
                            life: 3000
                        });
                        return;
                    }

                    this.dados_drtis = res;

                    if(callback) callback();
                }
            });

        },

        save_config_wa() {
            this.$util.atualizar(this, {
                service: 'parametro_unidades',
                func: 'store',
                dados: {
                    ...this.lista,
                    wa_config: true,
                },
                modal: 'waModal',
                reload: true,
            });
        },

        save_config_sms() {
            this.$util.atualizar(this, {
                service: 'parametro_unidades',
                func: 'store',
                dados: {
                    ...this.lista,
                    sms_config: true,
                },
                modal: 'smsModal',
                reload: true,
            });
        },

        config_proced() {
            this.$refs.proceds.abrir();
        },
        test_config_pagamento() {
            this.testing = true;

            this.$util.loadItem(this, {
                service: 'pagamentos_online',
                func: 'teste',
            })
            .then(res => {
                alert(res);
            })
            .finally(() => {
                this.testing = false;
            });
        },

        config_pagamento() {
            this.config_pag = {
                merchant_id: this.lista.merchant_id,
            };
            $('#providerConfigModal').modal('show');
        },

        atualizar_config_pag() {
            this.lista.js_pag_online_config = {
                merchant_id: this.config_pag.merchant_id,
                merchant_key: this.config_pag.merchant_key,
            };

            this.modal_aberto = "providerConfigModal";

            this.atualizar();
        },
        atualizar_telegram() {
            if ( !this.lista.st_telegram_bot_token ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Necessário informar o token do bot.",
                    life: 3000
                });
                return;
            }

            this.$util.atualizar (this, {
                service: 'telegram',
                func: 'config',
                dados: {
                    ...this.lista
                },
                callback: (res) => {
                    if ( res.me && res.me.ok ) {
                        $('#telegramTokenPortal').modal('hide');
                        this.load();
                    } else {
                        alert('Falha na atualização do token do bot.');
                    }
                },
            });
        },

        load () {
            this.$util.load (this, {
                service: 'parametro_unidades',
                parms: {
                    cadastro: true,
                },
                loadTo: res => {
                    if ( !res[0].js_turnos ) {
                        res[0].js_turnos = {
                            M: {
                                de: 7,
                                ate: 13
                            },
                            T: {
                                de: 13,
                                ate: 18
                            },
                            N: {
                                de: 18,
                                ate: 21
                            }
                        };
                    }

                    this.dados = res;
                }
            });
        },
        atualizar () {
            this.$util.atualizar (this, {
                service: 'parametro_unidades',
                dados: { ...this.lista },
                toast: true,
                modal: this.modal_aberto,
            });
        },
    },

    mounted () {

        let query = { q: [
            {
                name: 'pacs_configuracao.index',
                id: 'pacs',
            },
            {
                name: 'configuracoes.servicos_whatsapp',
                id: 'servicos_whatsapp'
            }
        ]};

        this.axios.post('/aql', query)
            .then(res => {
                
                if ( res.data.pacs.status == 200 ) {
                    this.servicos = res.data.pacs.data;
                }
                if (res.data.servicos_whatsapp.status == 200) {
                    this.servicos_whatsapp = res.data.servicos_whatsapp.data
                }
                
            })
            .finally(() => {
                this.$store.commit('loading', false);
                this.load();
            });

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Outras Configurações", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },
    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>
